import { ALLOWED_UTM_PARAMETERS } from '../utils/urlUtils';
export const isUtmParameterKeyType = key => {
  return ALLOWED_UTM_PARAMETERS.includes(key);
};